import { render, staticRenderFns } from "./Heranca.vue?vue&type=template&id=38a855d8"
import script from "./Heranca.vue?vue&type=script&lang=js"
export * from "./Heranca.vue?vue&type=script&lang=js"
import style0 from "./Heranca.vue?vue&type=style&index=0&id=38a855d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports